import { render, staticRenderFns } from "./UtilityPubDetailComponent.vue?vue&type=template&id=59b94b8e&scoped=true&"
import script from "./UtilityPubDetailComponent.vue?vue&type=script&lang=js&"
export * from "./UtilityPubDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b94b8e",
  null
  
)

export default component.exports